<template>
  <table class="table table-sm table-bordered diff-table">
    <thead>
      <tr>
        <th style="width: 180px">Campo</th>
        <th style="width: 45%">Antes</th>
        <th style="width: 45%">Depois</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="field in changedFields" :key="field">
        <td class="field-label">{{ labelFor(field) }}</td>
        <td class="cell-antes">
          <FieldValueRenderer
            :field="field"
            :value="antes[field]"
            variant="antes"
            :counterpart="novos[field]"
            :resolver="resolver"
            :resolvable-fields="resolvableFields"
          />
        </td>
        <td class="cell-depois">
          <FieldValueRenderer
            :field="field"
            :value="novos[field]"
            variant="depois"
            :counterpart="antes[field]"
            :resolver="resolver"
            :resolvable-fields="resolvableFields"
          />
        </td>
      </tr>
      <tr v-if="changedFields.length === 0">
        <td colspan="3" class="text-muted text-center">— sem alterações —</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import FieldValueRenderer from './FieldValueRenderer.vue';

const DEFAULT_FIELD_ORDER = [
  // Identidade
  'titulo', 'descricao', 'label', 'tag_produto',
  // Visual
  'cor', 'icone', 'imagem_desktop', 'imagem_mobile',
  // Comportamento
  'ativo', 'home', 'exibe_titulo', 'exibe_descricao', 'destacar_produto', 'ordem',
  // Regra de produtos
  'tipo_regra', 'coluna', 'banco', 'sql', 'tagsFiltro', 'produtos',
  // Exibição
  'sistemas',
];

export default {
  name: 'UnifiedDiffTable',
  components: { FieldValueRenderer },
  props: {
    antes: { type: Object, default: () => ({}) },
    novos: { type: Object, default: () => ({}) },
    labels: { type: Object, default: () => ({}) },
    fieldOrder: { type: Array, default: () => DEFAULT_FIELD_ORDER },
    resolver: { type: Function, default: null },
    resolvableFields: { type: Array, default: () => [] },
  },
  computed: {
    changedFields() {
      const keys = new Set([
        ...Object.keys(this.antes || {}),
        ...Object.keys(this.novos || {}),
      ]);
      const order = this.fieldOrder;
      return Array.from(keys).sort((a, b) => {
        const ia = order.indexOf(a);
        const ib = order.indexOf(b);
        if (ia === -1 && ib === -1) return a.localeCompare(b);
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    },
  },
  methods: {
    labelFor(field) {
      return this.labels[field] || this.humanize(field);
    },
    humanize(field) {
      return String(field)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
  },
};
</script>

<style scoped>
.diff-table {
  font-size: 13px;
  margin-bottom: 0;
}

.diff-table th {
  background: #f4f5f7;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #667085;
}

.field-label {
  font-weight: 600;
  color: #344054;
  background: #fafbfc;
}

.cell-antes {
  background: #fff7f6;
  border-left: 3px solid #f2b8b5;
}

.cell-depois {
  background: #f0faf3;
  border-left: 3px solid #95d5b2;
}

.diff-table td {
  vertical-align: top;
  word-break: break-word;
}
</style>
